import React from 'react';
import classNames  from 'classnames';
import cn from './styles.module.scss';

type WidgetProps = {
  className?: string;
  children?: React.ReactNode;
}

export function Widget({ className, children }: WidgetProps) {
  return (
    <div className={classNames(cn.widget, className)}>
      {children}
    </div>
  );
}
